<div class="section">
  <div class="title-section header tw-flex-col tw-items-start lg:tw-flex lg:tw-items-center" *ngIf="showHeader">
    <h2 class="text-title-md-bold">
      Perfil del paciente <span class="text-info">{{ (appointment$ |
        async)?.status | getTranslateEnum:'appointmentStatus' }}</span>
    </h2>
    <div *ngIf="(appointment$ | async) as appointment" class="tw-mt-5 lg:tw-mt-0 tw-flex tw-flex-col tw-gap-4 tw-justify-end sm:tw-flex-row shepherd-appointment-btn-actions" id="shepherd-appointment-btn-actions">
      <ng-container *ngIf="appointment.status !==
        appointmentStatusEnum.CANCELLED && appointment.status !==
        appointmentStatusEnum.COMPLETED && appointment.expert &&
        (appointment.expert.available || appointment.expert.available ===
        undefined)">
        <button nz-button nzType="default" class="cancel-appointment-button"
          (click)="onEmitCancelAppointment()"><i nz-icon nzType="close-circle"
            nzTheme="outline"></i>Cancelar cita</button>
        <button *ngIf="showRescheduleButton" nz-button nzType="default"
          class="reschedule-appointment-button" (click)="onEmitRescheduleAppointment()"><i nz-icon
            nzType="calendar" nzTheme="outline"></i>Reprogramar</button>
      </ng-container>
      <button
        *ngIf="appointment.status !== appointmentStatusEnum.CANCELLED &&
        userLogged?.experts"
        (click)="onEmitGoToConsultation()"
        nz-button nzType="primary"
        class="shepherd-btn-start-appointment">
        <i nz-icon [nzType]="consultationIsOutOfDate ? 'eye' : 'arrow-right'"
          nzTheme="outline"></i>
        {{ consultationIsOutOfDate ? 'VER DETALLES' : 'INICIAR LA CITA' }}</button>
    </div>
  </div>

  <div class="container-indicators" *ngIf="(appointment$ | async) &&
    ((appointment$ | async)?.expert) && (this.patientSelected)"><!-- && (appointment$ | async).clinicBranch -->
    <app-appointment-details
      [setNewDivAndWhiteBackground]="true"
      [appointmentType]="((appointment$ | async)?.type !== appointmentTypeEnum?.CONFERENCE) ? ( (appointment$ | async)?.type ) : null"
      [branchName]="((appointment$ | async)?.clinicBranch) ? ((appointment$ | async)?.clinicBranch?.name) : null"
      [expertName]="(appointment$ | async)?.expert?.user?.name + ' ' + (appointment$ | async)?.expert?.user?.lastname"
      [expertSpeciality]="(appointment$ | async)?.expert?.specializationName"
      [url]="(appointment$ | async)?.meetUrl"
      [note]="(appointment$ | async)?.meetNote"
      [date]="(!((appointment$ | async)?.startDate.date | isToday) ? ((appointment$ | async)?.startDate.date | date:'mediumDate') : 'Hoy')"
      [hourFrom]="((appointment$ | async)?.startDate.date | date:'HH:mm a')"
      [hourTo]="((appointment$ | async)?.endDate.date | date:'HH:mm a')"
      [location]="((appointment$ | async)?.type === appointmentTypeEnum?.ON_SITE) ? ( (appointment$ | async)?.clinicBranch?.address ) : null"
      [duration]="(appointment$ | async)?.duration" [totalAppointmentsInService]="((appointment$ | async)?.metadata?.totalAppointmentsInService) || 0"
      [cardStyles]="cardConsultationStyles"
      [visibleTotalAppointmentsInService]="(this.appointment$ |async).metadata.demo !== true"
    ></app-appointment-details>
  </div>
  <!--
    Se ocultó los cards que mostraban a los pacientes de una cita
  <div class="container-patients mt-xlg" *ngIf="patients.length > 1">
    <div *ngFor="let patient of patients; index as i" class="container-app-card-patient mr-xlg mb-xlg">
      <app-card-patient
        (click)="onSelectPatient(patient._id)"
        [short]="true"
        [active]="patient._id === patientSelected._id"
        [ngClass]="{'mb-xlg': i < (patients.length - 1), 'mb-none': i >= (patients.length - 1)}"
        [name]="patient.user.name"
        [lastName]="patient.user.lastname"
        [gender]="patient.user.gender"
        [imageProfile]="patient.user.profileImageURL"></app-card-patient>
    </div>
  </div>
  -->
  <div nz-row class="card-container-shadow" *ngIf="patientSelected &&
    patientSelected.user && !hideHabits" [@fadeInAnimation] [ngStyle]="cardStyles">
    <div class="title-section">
      <h3 class="text-title-md">{{ patientSelected?.user?.name }} {{
        patientSelected?.user?.lastname }} <span
          *ngIf="patientSelected.user?.birthday">( {{
          (patientSelected.user.birthday | getAge) + ' años' }} )</span></h3>
      <button (click)="onEmitEditionMode()" *ngIf="showEditable" nz-button
        nzType="default" class="btn-default"><i nz-icon nzType="edit"
          nzTheme="outline"></i>Editar</button>
    </div>
    <div nz-row class="user-info mb-sm">
      <div nz-col nzXs="24" nzMd="4" nzXl="3" class="avatar-section img mr-sm">
        <app-avatar-user [image]="patientSelected.user.profileImageURL"
          [name]="patientSelected?.user?.name"
          [lastname]="patientSelected?.user?.lastname" [width]="75"
          [fontSize]="'25px'"></app-avatar-user>
      </div>
      <div nz-col nzXs="24" nzMd="20" nzXl="21">
        <div class="info-container">
          <div class="flex-column">
            <span class="text-subtitle-bold-upper title-header">Género</span>
            <img loading="lazy" *ngIf="patientSelected.user.gender === genderEnum.FEMALE"
              class="gender-class"
              src="./../../../assets/images/icons/icons8-female-100.png" alt="">
            <img loading="lazy" *ngIf="patientSelected.user.gender === genderEnum.MALE"
              class="gender-class"
              src="./../../../assets/images/icons/icons8-male-100.png" alt="">
          </div>
          <div class="flex-column">
            <span class="text-subtitle-bold-upper title-header">Fuma</span>
            <!-- <span class="text-regular-14">{{ patientSelected.habits.smoke ? 'Sí'
              : 'No' }}</span> -->
          </div>
          <div class="flex-column">
            <span class="text-subtitle-bold-upper title-header">Toma alcohol</span>
            <!-- <span class="text-regular-14">{{ patientSelected.habits.drinkAlcohol
              ? 'Sí' : 'No' }}</span> -->
          </div>
          <div class="flex-column">
            <span class="text-subtitle-bold-upper title-header">Toma café</span>
            <!-- <span class="text-regular-14">{{ patientSelected.habits.drinkAlcohol
              ? 'Sí' : 'No' }}</span> -->
          </div>
        </div>
      </div>
    </div>

    <div nz-row [nzGutter]="16" class="user-info align-items-start">
      <div nz-col nzXs="24" nzMd="12" nzXl="10" class="description-item">
        <span class="text-subtitle-bold-upper title-header">Motivo</span>
        <span class="text-info">{{ goal || 'Sin motivo'}}</span>
      </div>
      <div nz-col nzXs="24" nzMd="12" nzXl="14" class="description-item">
        <span class="text-subtitle-bold-upper title-header">Objetivo</span>
        <p class="text-info" *ngIf="!clinicalObjectives ||
          clinicalObjectives.length === 0">Sin objetivos clínicos</p>
        <div nz-row [nzGutter]="[0, 7]">
          <div nz-col *ngFor="let objective of clinicalObjectives">
            <nz-tag class="tag" [style.background-color]="objective |
              setClinicalObjectiveColor">{{ objective.text }}</nz-tag>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
